import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { WaveSine } from '@phosphor-icons/react';

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-zinc-950">
        <WaveSine size={32} weight="duotone" className="text-[#ccff00] animate-pulse" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace state={{ from: location }} />;
  return children;
}
